export const taxConfigsReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_TAX_CONFIGS_REQUEST":
      return { loading: true };
    case "GET_TAX_CONFIGS_SUCCESS":
      return {
        ...state,
        loading: false,
        taxConfigs: action.payload.taxConfigs || [],
        success: action.payload.success,
      };
    case "GET_TAX_CONFIGS_FAILED":
      return { ...state, loading: false, error: action.payload };
    case "CLEAR_ERRORS":
      return { ...state, error: null };
    default:
      return state;
  }
};

export const createTaxConfigReducer = (state = {}, action) => {
  switch (action.type) {
    case "CREATE_TAX_CONFIG_REQUEST":
      return { loading: true };
    case "CREATE_TAX_CONFIG_SUCCESS":
      return {
        ...state,
        loading: false,
        success: action.payload.success,
        message: action.payload.message,
        taxConfig: action.payload.taxConfig,
      };
    case "CREATE_TAX_CONFIG_FAILED":
      return { ...state, loading: false, error: action.payload };
    case "CREATE_TAX_CONFIG_RESET":
      return { ...state, success: false, message: null, taxConfig: null };
    case "CLEAR_ERRORS":
      return { ...state, error: null };
    default:
      return state;
  }
};

export const updateTaxConfigReducer = (state = {}, action) => {
  switch (action.type) {
    case "UPDATE_TAX_CONFIG_REQUEST":
      return { loading: true };
    case "UPDATE_TAX_CONFIG_SUCCESS":
      return {
        ...state,
        loading: false,
        success: action.payload.success,
        message: action.payload.message,
        taxConfig: action.payload.taxConfig,
      };
    case "UPDATE_TAX_CONFIG_FAILED":
      return { ...state, loading: false, error: action.payload };
    case "UPDATE_TAX_CONFIG_RESET":
      return { ...state, success: false, message: null, taxConfig: null };
    case "CLEAR_ERRORS":
      return { ...state, error: null };
    default:
      return state;
  }
};

